import { Pipe, PipeTransform } from '@angular/core';
import { formatLocalizedDate } from 'src/app/controls/viva-date-input/date-format.util';
import { LocaleService } from 'src/app/services/locale-service/locale.service';

/**
 * Culture-aware date/time pipe. Uses the in-app BCP-47 culture from LocaleService
 * instead of Angular's bootstrap LOCALE_ID (which keeps English weekday/month names).
 *
 * Impure so language switches refresh displayed dates without remounting the view.
 *
 * @example
 * {{ expires | localizedDate:'EEEE HH:mm' }}
 * {{ purchased | localizedDate:'mediumDate' }}
 */
@Pipe({
  name: 'localizedDate',
  standalone: true,
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private readonly localeService: LocaleService) {}

  transform(
    value: string | Date | null | undefined,
    formatKey: string = 'mediumDate',
  ): string {
    return formatLocalizedDate(value, this.localeService.getCulture(), formatKey);
  }
}
